 <mat-form-field appearance='outline' style = "width: 100%;">
    <mat-label>Csomag</mat-label>
    <mat-select [formControl] = "formControl" >
        <mat-option *ngFor = "let packageDefinition of packageDefinitions" [value] = "packageDefinition.uuid">
            {{ packageDefinition.displayedName }}
        </mat-option>
    </mat-select>
    <mat-error *ngIf = "formControl.hasError('required')"> Kötelező mező!</mat-error>
</mat-form-field>
